module.exports = __webpack_public_path__ + "img/Frame-80.d77a3577.svg";